import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-front-layout',
    templateUrl: './front-layout.component.html',
    styleUrls: ['./front-layout.component.css'],
    standalone: false
})
export class FrontLayoutComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit() {
  }

}
